module.exports = __webpack_public_path__ + "img/cancelIcon.cc807c32.svg";